// Project data caching service
class ProjectCacheService {
  constructor() {
    this.cache = new Map();
    this.CACHE_TTL = 5 * 60 * 1000; // 5 minutes cache TTL
  }

  // Generate cache key for a project
  getCacheKey(userId, projectName) {
    return `${userId}-${projectName}`;
  }

  // Get cached data for a project
  get(userId, projectName) {
    // Validate userId to prevent cross-user cache access
    if (!userId) {
      console.warn('ProjectCache: Attempted to get cache without userId');
      return null;
    }
    
    const key = this.getCacheKey(userId, projectName);
    const cached = this.cache.get(key);
    
    if (!cached) return null;
    
    // Check if cache is still valid
    const now = Date.now();
    if (now - cached.timestamp > this.CACHE_TTL) {
      this.cache.delete(key);
      return null;
    }
    
    return cached.data;
  }

  // Set cache data for a project
  set(userId, projectName, data) {
    // Validate userId to prevent cross-user cache pollution
    if (!userId) {
      console.warn('ProjectCache: Attempted to set cache without userId');
      return;
    }
    
    const key = this.getCacheKey(userId, projectName);
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      userId // Store userId for validation
    });
  }

  // Clear cache for a specific project
  clear(userId, projectName) {
    const key = this.getCacheKey(userId, projectName);
    this.cache.delete(key);
  }

  // Clear all cache
  clearAll() {
    this.cache.clear();
  }

  // Clear cache for a user
  clearUser(userId) {
    for (const key of this.cache.keys()) {
      if (key.startsWith(`${userId}-`)) {
        this.cache.delete(key);
      }
    }
  }
}

export const projectCache = new ProjectCacheService();